export const vatDetailsObject = {
    "ZEG": { "VATGroup": "Zero Rate Goods", "VATPercentage": "0" },
    "THG": { "VATGroup": "3% Rate Goods", "VATPercentage": "3" },
    "LOG": { "VATGroup": "Low Rate Goods", "VATPercentage": "5" },
    "REG": { "VATGroup": "Reduced Rate Goods", "VATPercentage": "9" },
    "STG": { "VATGroup": "Standard Rate Goods", "VATPercentage": "19" }
  };